module.exports = __webpack_public_path__ + "img/sec1_07.461943cc.png";